module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("‘W")])]), _vm._v("hat an extraordinary coincidence!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William Pemberton raised his distinguished head at his sweet wife’s acid tone. Blue eyes that had been solemnly contemplating the brandy warming within his broad palm now met a glass-sharp gaze. It was a glancing contact, for her attention was already slicing past his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Your old friend is again socialising with us, William. Suddenly we appear to share many mutual acquaintances with Lady Bingham. She looks a little disappointed… Ah, but she has now spotted you and looks far less glum.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘June…’ William’s weary sigh accompanied his wife’s name.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("June Pemberton bestowed on her husband a fleeting, bright smile. ‘I shall not hamper your fond reminiscences this time, I promise. I was about to ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("find my sisters, in any case.’ June made to sweep away, her ivory skirts held in fingers so tightly clenched the delicate silk was imperilled.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have had enough of this interminable innuendo,’ William gritted with a fierce azure look at his spouse from beneath heavy lashes. An unusually masterful hand on the soft skin of her arm stayed her. ‘Accuse me or have done!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Accuse you? Of what, pray?’ June countered, her complexion becomingly flushed. She was already regretting revealing that the elegant brunette, who had just entered the Cleggs’ ballroom, had unsettled her to such a degree. Three times this week they had socialised. Three times Lady Constance Bingham had arrived shortly after they did, and on each occasion the pretty dowager had contrived at some point in the evening to corner William, in order to engage him in quite an intimate and cosy chat about the old days when once they had been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("close")]), _vm._v(". And what worried June was she had recently discovered that once, indeed, they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been close.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("In the previous few months Constance Bingham had limited her interest in William to lingering looks when their carriages passed on an afternoon drive, or a coquettish glance when they found themselves browsing the same parade of shops. In those early days, an arch comment from June congratulating her husband on his new allure had rendered him amused, ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("then thoughtful, then murmuring that he believed she must be mistaken over it all. He had reminded her of his reputation as rather a dull fellow. She must look to her dashing brothers-in-law for gentlemen cast creditably in the role of gallant, he had told her with a wry grin that melted her heart. Thus, initially, she had felt an amount of pride that her William was drawing the attention of such a well-connected society lady.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that was a month or more ago and Lady Bingham’s interest was becoming insistent enough for others to notice and remark upon it. Not within June’s hearing, of course; she was well aware that conversations sometimes dwindled on her arrival in an elegant drawing room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Recently she had been on the point of demanding to know whether she was invisible, so blatantly had Lady Bingham been flirting with her husband, but angry tears had been too close to the surface for her to risk challenging the woman and making a fool of herself. Lady Bingham was making it clear she found her quarry’s wife of no consequence, and that was galling. Dwelling on that truth now made her snap. ‘Is it not coincidence then that Lady Bingham materialises at every social function we attend? And am I to believe it was simply good manners that obliged you to escort her to the terrace when she complained of feeling faint earlier this week?’")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘God’s teeth!’ The oath was so explosive that a lady and gentleman close by slanted curious eyes at William’s taut features. ‘I believe I explained that incident at the time.’ The words were enunciated through lips that scarce moved. ‘Lady Bingham said she felt faint and asked me to accompany her outside for some air. Would you rather I had acted the boor and allowed her to collapse at my feet?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June’s amber eyes glowed tiger-bright as she dulcetly demurred. ‘Indeed, no, sir. I would rather you had recommended she used her salts or, better still, went home. But whatever you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" do to revive her certainly worked. When you later reappeared together she looked quite red in the face…radiant, I believe your mother put it when she drew my attention to you both.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William closed his eyes and a low curse scratched at his throat. ‘I might have guessed my mother would have some part in it. Come. We are leaving. I have had enough.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("‘Too late, I fear.’ His wife darted a look across his broad shoulder. ‘Lady Bingham is being escorted to meet you by your parents.’ With a flick of the wrist June had opened her reticule. A cold metal bottle was extracted and thrust into her husband’s hand. ‘Here! Take my hartshorn. Feel free to offer it to your admirer should she be in danger of swooning over you. ‘Twould prevent a trip to the terrace and her ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("risking pneumonia. That scrap she has on is positively indecent and will provide little protection against the night chill.’ Without another word June turned and walked away.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William watched the ripple and sway of cream silk as his wife gracefully fled from him. The cascade of berry-blonde curls that curtained her nude sculpted shoulders glimmered in candlelight, stoking his frustrated desire. With a low sigh he forced his hungry eyes away. He hadn’t investigated the approach of the people June had warned were nearby and, with rare incivility, avoided them by moving in the opposite direction. He felt unequal this evening to receiving any of his mother’s studied bonhomie or Lady Bingham’s coquetry. And he knew both were his if he remained where he was. But a quiet chat with his father would have been welcome. With a scowl moulding his mouth, he finished what was in his glass and weaved a path through a throng of people, hoping to find some uncomplicated male company.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("As he walked he thought. He hadn’t wanted to leave the house this evening, sensing this situation might arise, but June, with a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("faux")]), _vm._v(" gaiety, had evaded his amorous persuasiveness that they have a quiet night at home, and insisted they come. They had both known for some weeks that a confrontation about Lady Bingham’s peculiar attention to him was ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("imminent. A constant strain between them was upsetting their conjugal harmony, and thus William’s equable nature.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William was coming to accept that his wife’s suspicions were valid. Wherever they went, Constance was likely not only to materialise, but also to hound him. He knew too that June’s mild annoyance at the woman’s stalking had turned to a stronger emotion since they had become the butt of gossip. The fact that his own mother was fostering Constance’s friendship and thus exacerbating the friction between him and June was obviously intriguing the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _vm._v(". William, on the other hand, was well used to his mother’s hostility to his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is June ailing? She looked quite sickly, I thought, as she passed me a moment ago, with barely a greeting, too, I might add.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William closed his eyes and blew a silent curse through his teeth on recognising the voice accosting him. It was wrong to have supposed his mother would give up pursuit quite so easily, even if Constance and his father had. On the edge of his vision he noticed his father leading Lady Bingham towards the supper room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Pamela Pemberton fussily hoisted a flimsy shawl about her thin arms. ‘Really, William! I think you ought have a word with your wife about her manners. Several years you have been wed; time enough by ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("my reckoning for her early breeding to have been polished a little by association with us.’")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William Pemberton gazed glacially at his mother. ‘Yes, several years married, ma’am, and still she suits me as well as ever she did.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela sniffed. ‘Still your nursery is empty. Where is my grandchild?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You have a granddaughter, as I recall… Hannah’s child.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have no daughter. I have had no daughter since she married that heathen.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Your choice, then, to have no grandchild either,’ William pointed out, his voice vibrating with disgust. ‘Your loss, too, for the little girl is beautiful and I’m proud to call her my niece.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That is understandable.’ His mother theatrically sighed. ‘Perhaps, if your wife suits you so very well, you must resign yourself to doting on other people’s offspring.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Indeed I shall, if that is how it is to be.’ William turned away from the sight of his mother’s bitter, pinched features. ‘We are going home. June is unwell and is just gone to take her leave of her sisters.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Going home?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William removed the tenacious fingers that had fastened on his arm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("‘But you have barely arrived. This is one of the ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("most lavish parties we shall see this season. You cannot go! Constance is here and keen to come to you.’")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why is that?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why is what?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why is Constance keen to come to me? There are other people here she knows. Why single me out as a person on whom to bestow such favour?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps she finds you amusing…’ The innocent simper that accompanied the remark was belied by the flush staining Pamela’s cheeks. ‘Oh, how should I know?’ she blustered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I just thought you might, ma’am…’ was William’s parting shot as with a curt nod he moved on.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If she’s on the prowl for a husband now she’s out of her widow’s weeds, the least she can do is find one of her own.’ Rachel Flinte, Countess of Devane, cast a belligerent glance at the back of Lady Bingham’s coiffure as she made the remark.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And it shouldn’t be that difficult to attract one either, if rumours are true about what old Charlie Bingham bequeathed her,’ Mrs Isabel Hauke contributed to the debate. ‘Etienne said that it is rumoured he left her properties in three counties and a brace of ships docked in Bristol. Quite a lure for a gentleman with pockets to let.’")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June looked at her two older sisters and gave a wry smile. ‘Thank you! I wish you hadn’t told me that. She really is a catch. And besides…she is a very attractive woman, isn’t she?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel shrugged dismissively. ‘A person who favours Amazonian brunettes might think so.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabel gave a toss of her mermaid hair. ‘And William patently does not,’ she roundly emphasised. ‘The man’s as besotted with you as ever he was. Since you left him moments ago his eyes have tracked you constantly. He looks…a little furious, June, not at all his usual suave self,’ Isabel warned. ‘And, now he’s free of that witch of a parent of his, he appears to be heading this way.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June unconsciously tidied her sleek blonde ringlets on learning that information. Her sister’s description of the wealthy widow was rather uncharitable, she knew. Constance Bingham was attractively tall and willowy and her hair was a rich shade of chestnut. And June had recently learned that her husband "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" find Lady Bingham attractive…or once he had.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June’s irritation over Lady Bingham constantly paying attention to William was transforming to jealousy since her mother-in-law had let her know that the couple had once been in love. But she found herself unable to challenge William over it, for had he not voluntarily mentioned his aborted betrothal to her himself several years ago?")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William had been engaged to a Miss Palmer when he was twenty. He had told her that when first they met, and that Miss Palmer jilted him for a wealthier man. He had seemed philosophical about it all and reluctant to elaborate. It was just an inconsequential part of his youth, he had said on dismissing the affair. At that time June had not pressed him for further details of an alliance that had ended before they met, deeming it bad manners, and unnecessary. She had practically forgotten all about the matter, for why should it bother her? William had married her. William loved her. Just a few short months ago had he not told her so at least once a day, and again impressed it on her with sweet passion at night? But now a wedge of tension was nudging them apart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her mother-in-law had been good enough to satisfy her unspoken curiosity about the woman’s past, and William’s part in it. Constance Bingham, née Palmer, was returned to town from Devonshire and socialising again now her mourning for her late husband was done. Was June aware that William had almost married such a personable lady? Pamela Pemberton had asked with a satisfied twitch of a smile when her daughter-in-law’s expression made it clear she was not. Since that time an icy feeling had been curdling June’s stomach, for how blatantly the widow was parading in her face the fact that she still found her erstwhile fiancé attractive.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Isabel and Rachel exchanged a glance on noticing June’s unhappy preoccupation. Her small teeth were sunk low in her bloodless bottom lip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If William wasn’t such a perfect gentleman, I’m sure he would have by now made it clear that Constance Bingham vexes him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is he almost upon us?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At her sister Isabel’s discreet nod, June tilted her heart-shaped face. ‘Well, smile, then. I won’t have him thinking I’m a jealous shrew, even if I stupidly did act like one earlier this evening.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘William!’ Rachel greeted her brother-in-law and slipped a hand through his arm. ‘Connor was looking for you earlier. I believe he went along to the card room thinking you might be playing at the tables.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William gave his sisters-in-law a charming smile. ‘Another time, maybe. June and I are leaving.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June shot her husband a startled look. Her elfin face was animated by slashes of colour staining her cheekbones. ‘How masterful you sound!’ she playfully remarked. ‘You will make Rachel and Isabel think I am to be taken home in disgrace. I would rather stay. We were about to find the supper room.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("As June made to link arms with her sisters and urge them on, William arrested her progress and drew her to his side. His head inclined intimately close to hers in the manner of a fond spouse. ‘Most of these good people would love a little more reason to gossip over ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("us, June,’ was murmured into a delicate ear. ‘Let us at least be in agreement over quitting this infernal place even if all else lately has us at odds. Here, make your malady look real and sniff your hartshorn, my love.’")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June slid a look from beneath her luxurious lashes at her husband as he returned her the small silver bottle she had forced upon him earlier. Their eyes clung and his lips tilted in an engaging smile that mingled seduction and threat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June felt her stomach tighten. She rather thought she knew how her husband would seek reconciliation once they were private tonight. Would she allow it? Her fair complexion tinged rose and her limbs were already a-tremble with anticipation. ‘It seems I must be a dutiful wife then and oblige my lord and master.’ Just a hint of sourness betrayed her lingering hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William glanced at his sisters-in-law, who had diplomatically distanced themselves, before casting a trenchant look upon his wife. ‘It would certainly be novel if you did, my sweet,’ William drawled, with a significant irony that she understood and that made her blush deepen. ‘It seems to me overlong since you obliged me in a solitary thing.’ With his hand on her elbow and a nod for her sisters, he led her away.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("A heavy frosty atmosphere that had little to do with the glittering pavements accompanied the ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("couple homeward to Bay House in St James’s. Once or twice June sought, with a fluttering glance, to decipher the expression on her husband’s shadowy countenance. She had believed he might take her in his arms as soon as they were settled on the upholstery for the hand upon her waist, as he helped her into their carriage, had been wonderfully caressing. But, once seated, he had put his head back into the squabs and assessed the carriage roof as though stars were visible through it. Far from rebuffing his amorous advances, as she believed she would—until she had some reassuring answers from him over that shameless widow stalking him—she now found herself summoning the courage to slip on to his seat and cuddle up to him. June tilted up her chin. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She")]), _vm._v(" was not at fault in this. Neither, she suspected, was William. But she felt fragile and vulnerable and in need of a little reassurance from the man she loved that she was cherished now, tonight, as surely as she had been a few months ago when Lady Constance Bingham, née Palmer, was blissfully unknown to her.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It is a very cold night,’ June remarked into the silence with a peek out at the quiet whiteness. When a grunt was all the encouragement she received for her attempt at rapprochement, she snuggled into the seat and wrapped her arms about her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Her husband’s face was still angled upwards, his ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("eyes half-closed, when she heard, ‘Are you chilled?’")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ she eagerly answered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William uncrossed his arms, opened them invitingly and with no further encouragement his wife hurtled gracefully into them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William folded his great coat about June’s slender body. Instinctively she curved against his side and was anchored there in a familiar way. Warm lips grazed across her cool forehead, while deft hands within the enveloping cloak warmed her silken limbs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What is happening to us, William?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sobbing little query made her husband groan and lift his petite wife atop his lap. A hand smoothed her cheek; his lips followed as he felt the wetness there. ‘What is happening to us, June, is that we are allowing mischief-makers to meddle in our life. We must not allow them to succeed,’ he whispered huskily. ‘If that means choosing very carefully with whom we socialise, and where we go, then so be it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June nodded against his coat. ‘You were right earlier; we should have stayed home. I have not enjoyed one second of the Cleggs’ ball.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We need not become recluses, but you know how gossips thrive if one seems affected by their malice. What else have the bitter souls to do but try to spread their misery?’")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why does she hate me so? I have tried hard to please her and be a good daughter-in-law…’ June choked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William cupped tender fingers over his wife’s jaw. ‘And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" have told you not to try so hard. You do not have to justify your status as my wife. She is my mother, that I cannot change, but you, I chose. You, I want. You, I will always want, no matter you came to me with little dowry and no aristocratic relations. Your father and mother are fine people. All your sisters I’m proud to call my sisters. My brothers-in-law I’m happy to do business with and call close friends. You suit me perfectly. You always have.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And your mother resents it, I know she does. She would have had you marry a nobleman’s daughter…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then she is a fool for not recognising "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" is exactly what I have done. I have married a very noble man’s daughter.’")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f16d33f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459225282_ch01.vue
// module id = 75
// module chunks = 0